import axios from 'axios';
const base = 'datealert';

function getAll(query = null) {
    return axios.get(base, { params: query });
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data?.id_das].join('/'), data);
}

const AlertDateSalesService = {
    getAll,
    register,
    update
};
export default AlertDateSalesService;
